import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  divider: {
    height: "1px",
    backgroundColor: "rgba(230, 230, 230, 0.5)",
    margin: "30px 0 20px"
  },
  companyFieldWrapper: {
    position: "relative"
  },
  questionIcon: {
    position: "absolute",
    top: "21px",
    left: "245px"
  },
  iconSize: {
    width: "24px",
    height: "24px"
  }
});
